import { GOOGLE_MAPS_API_KEY } from '../api'; // Import API key if not hardcoded

function RouteMap({ job }) {

    const route = JSON.parse(job["query_route"]);

    // Ensure route is valid and has at least two points
    if (!route || route.length < 2) {
        return <div>Invalid route data</div>;
    }

    // Format lat,lng for URL
    const formatCoords = (point) => `${point.lat},${point.lng}`;

    const origin = formatCoords(route[0]);
    const destination = formatCoords(route[route.length - 1]);
    const waypoints = route.slice(1, -1).map(formatCoords).join('|'); // Use pipe separator for waypoints

    // Construct the Embed API URL
    const embedUrl = `https://www.google.com/maps/embed/v1/directions?key=${GOOGLE_MAPS_API_KEY}&mode=driving&region=EE&units=metric&origin=${encodeURIComponent(origin)}${waypoints ? '&waypoints='+encodeURIComponent(waypoints) : ''}&destination=${encodeURIComponent(destination)}`;

    return (
        <iframe
             style={{ border: 'none', backgroundColor: '#ddd', width: '100%', maxWidth: '600px', height: '450px' }} // Adjusted styles
             loading="lazy"
             allowFullScreen // Use camelCase for React props
             referrerPolicy="no-referrer-when-downgrade" // Recommended policy
             src={embedUrl}>
        </iframe>
    );
}

export default RouteMap;